export enum CrudMappings {
  create = 'c',
  read = 'r',
  update = 'u',
  delete = 'd',
}
